// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3VAHg","left":"StickyBox_left__3c7qL","right":"StickyBox_right__11Viy"};